export default __webpack_public_path__ + "media/images/images/raty/star-off-dfdefe1ef52e6a250dff760ecdb6a3af.png";